import { defineAdapter } from "@repo/adapter-core";
import {
  ALLHOMES_DEFAULT_CONFIG,
  AllhomesAdapterConfigSchema,
  resolveAllhomesConfig,
} from "./config.ts";
import { ALLHOMES_ADAPTER_META } from "./meta.ts";
import { parseAllhomesDetailHtml } from "./parser.ts";
import { buildPaginatedUrl, buildSearchUrl } from "./runtime.ts";

export * from "./config.ts";
export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const ALLHOMES_ADAPTER = defineAdapter({
  meta: ALLHOMES_ADAPTER_META,
  defaultConfig: ALLHOMES_DEFAULT_CONFIG,
  resolvedConfigSchema: AllhomesAdapterConfigSchema,
  resolveConfig: resolveAllhomesConfig,
  buildSearchUrl,
  // Search URLs can list sold, for-sale or rental listings: each is its own discovery lane.
  listingTypes: ["buy", "sold", "rent"],
  buildPaginatedUrl,
  // Allhomes accepts neither query-string date filter nor explicit
  // sort=date_desc — see runtime.ts. Until parseDiscoveryPreviews exists, the
  // window is enforced after the detail scrape (outOfScopeGuard).
  // TODO(raw-html-only, 2026-10-04): preview cards used to come from a Firecrawl JSON extract
  // (+4 credits/page). Write parseDiscoveryPreviews from stored discovery snapshots
  // (page_snapshots) to restore the discovery-stage date guard.
  // Allhomes listing pages don't surface URLs to Firecrawl's link extractor.
  // Brightdata's real-browser render captures the hydrated cards.
  brightdataDiscoveryFirst: true,
  // Property profile pages: the sale comes from the property's own history. See parser.ts.
  parseDetailHtml: parseAllhomesDetailHtml,
});
